<template>
  <div class="navmenu">
    <router-link
      :to="{ name: 'classIndex', params: { id: 1 } }"
      class="nav-link"
    >
      <img class="navmenuimg" :src="src" />
    </router-link>
  </div>
</template>

<script>
export default {
  props: ["src"]
};
</script>

<style>
.navmenuimg {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/IndexBanner.vue